import axios from '../base/axios';
import API_KEY from './key';

const GET_DOCUMENTAY = 'flixfrenzy/redux/GET_DOCUMENTAY';

// eslint-disable-next-line default-param-last
const documentaryReducer = (state = [], action) => {
  switch (action.type) {
    case GET_DOCUMENTAY:
      return action.payload;
    default:
      return state;
  }
};

export const getDocumentary = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=99`).then((res) => {
    dispatch({
      type: GET_DOCUMENTAY,
      payload: res.data,
    });
  });
};

export default documentaryReducer;
